var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"track_artwork",attrs:{"src":_vm.resolvedUri,"alt":"Track artwork"},on:{"error":_vm.onResolveError}})
}
var staticRenderFns = []

export { render, staticRenderFns }